import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import moment from 'moment-timezone';
import getQueryUtils, { attributeKeys } from '@/pages/partners/queryUtils';
import _ from 'lodash';
import { $aggregation_distance, tags_partner } from '@/utils/query-helpers';

// Returns the sort order for the query, guarding against a stale 'distance asc'
// value persisted in the URL. When distance filtering is inactive (no lat/lng),
// $aggregation_distance returns undefined and 'distance' is not added to
// $aggregations — sorting by it would cause a Postgres "column does not exist" error.
function getOrder(searchOrder, distanceAggregation) {
  const order = searchOrder || 'createdAt desc';
  if (order === 'distance asc' && !distanceAggregation) {
    return 'createdAt desc';
  }
  return order;
}

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4,
    distance = {},
  } = props;

  const [timestamp] = useState(moment().toISOString());
  // const stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  const distanceAggregation = $aggregation_distance(distance, '');

  const query = {
    where: {
      // distance: _.pick(distance, ['latitude', 'longitude']),
      eager: {
        $aggregations: _.remove([
          distanceAggregation,
          {
            type: 'sum',
            alias: 'numberOfHoursServed',
            column: 'hours',
            relation: 'partnerProjectEvaluations'
          },
          {
            type: 'sum',
            alias: 'totalOfContributionsProvided',
            column: 'contributionValue',
            relation: 'partnerProjectEvaluations'
          }
        ]),
        $where: {
          ...tags_partner(),
          $and: [...queryUtils.where]
        }
      }
    },
    pagination: {
      page: search.page || '1',
      pageSize: pageSize,
      order: getOrder(search.order, distanceAggregation)
    }
  };

  const result = useConnect('user.find', query, {
    keepPreviousData: true
  });

  return result;
}
